export enum PrepaymentFrequencyPt {
  FIVE_DAYS = '5 dias',
  TEN_DAYS = '10 dias',
  FIFTEEN_DAYS = '15 dias',
  TWENTY_DAYS = '20 dias',
  TWENTY_FIVE_DAYS = '25 dias',
  THIRTY_DAYS = '30 dias',
  WHOLE_PERIOD = 'Diária. Todo o período.'
}
